import { toast as sonnerToast, type ExternalToast } from "sonner";
import type { ReactNode } from "react";

const LEADING_ICON_REGEX = /^\s*[\p{Extended_Pictographic}\uFE0F]/u;

type NotificationMessage = ReactNode;

function withIcon(message: NotificationMessage, icon: string): NotificationMessage {
  if (typeof message !== "string") {
    return message;
  }

  if (LEADING_ICON_REGEX.test(message)) {
    return message;
  }

  return `${icon} ${message}`;
}

function notify(message: NotificationMessage, data?: ExternalToast) {
  return sonnerToast(withIcon(message, "🔔"), data);
}

notify.success = (message: NotificationMessage, data?: ExternalToast) =>
  sonnerToast.success(message, data);

notify.error = (message: NotificationMessage, data?: ExternalToast) =>
  sonnerToast.error(message, data);

notify.warning = (message: NotificationMessage, data?: ExternalToast) =>
  sonnerToast.warning(message, data);

notify.info = (message: NotificationMessage, data?: ExternalToast) =>
  sonnerToast.info(message, data);

notify.loading = (message: NotificationMessage, data?: ExternalToast) =>
  sonnerToast.loading(message, data);

notify.dismiss = sonnerToast.dismiss;
notify.custom = sonnerToast.custom;
notify.promise = sonnerToast.promise;

export { notify as toast };
